import { ITopScorers } from '@sky-it-livedata/livedata-sports-design-system';
import React, { Suspense } from 'react';

import { IComponentModel } from '../../typings/common-types';
import { validateModel } from '../../utils/props-validator';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const CompetitionTopScorersWrapper = React.lazy(() => import('./competition-top-scorers'));

export interface IDynamicCompetitionTopScorers extends IComponentModel<ITopScorers> {
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

const DynamicCompetitionTopScorers = ({
  /* istanbul ignore next: default value */ model = {} as ITopScorers,
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicCompetitionTopScorers) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <CompetitionTopScorersWrapper
      live={live}
      initialModel={validateModel(model) as ITopScorers}
      query={validateModel(query)}
    />
  </Suspense>
);

export default DynamicCompetitionTopScorers;
